<template>
    <div class="o-wrapper u-m-t4 u-m-t3@s">
        <div class="o-grid o-grid--center">
            <div v-if="members.length !== 0" class="o-grid__item u-width-10/12 u-width-full@l">
                <div id="vue-membersList" class="c-community__members">
                    <div class="c-community__member" v-for="member in members">
                        <a :href="'/u/' + member.username">
                            <div>
                                <img :src="member.avatar"/>
                                <p>{{member.name}}</p>
                            </div>
                            <span v-if="member.username">@{{member.username}}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div v-else class="o-grid__item u-width-8/12 u-width-full@l" v-if="showEmptyMessage">
                <div v-if="$root.user.username === $root.profile.username" class="c-empty-state">
                    <h4>Follow other {{$root.community.title}} members and develop community connections</h4>
                    <p>{{mineNoContentMessage}}</p>
                    <a :href="$root.community.url + '/members'"><img :src="$cdn('/img/avatar-default.svg')" width="100" height="100" alt="avatar"></a>
                </div>
                <div v-else class="c-empty-state">
                    <h4>{{theirNoContentTitle}}</h4>
                    <p>As soon as they do they will be listed here.</p>
                    <a :href="$root.community.url + '/members'"><img :src="$cdn('/img/avatar-default.svg')" width="100" height="100" alt="avatar"></a>
                </div>
            </div>
        </div>

        <!--<div class="o-grid u-m-y10 u-m-y6@m u-m-y4@s">-->
        <!--<div class="o-grid__item u-width-full u-align-center">-->
        <!--<a href="#0" class="c-btn c-btn&#45;&#45;red is-outline">Load more</a>-->
        <!--</div>-->
        <!--</div>-->

    </div>
</template>

<script>
import MasonryStore from "../../configs/masonry-store";

export default {
    data() {
        return {
            masonry: MasonryStore,
            members: [],
            showEmptyMessage: false,
            mineNoContentMessage: 'Following other ' + this.$root.brand.name + ' users allows you to easily keep track of their community contributions.  To get started simply click on the avatar icon below to search for users.',
            theirNoContentTitle: this.$root.profile.first_name + ' isn\'t following anyone yet'
        }
    },
    created() {
        this.$root.$on('profile-search-following', (data) => {
            this.fetchData(data);
        });
        this.fetchData();
        if (this.$root.community) {
            this.mineNoContentMessage = 'Following other ' + this.$root.community.title + ' users allows you to easily keep track of their community contributions.  To get started simply click on the avatar icon below to search for users.';
            this.theirNoContentTitle = this.$root.profile.first_name + ' isn\'t following anyone in the ' + this.$root.community.title + ' community yet';
        }
    },
    updated() {
        this.$nextTick(() => {
            this.reinitGrid()
        })
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData',
        '$route': 'reinitGrid'
    },
    methods: {
        fetchData(search) {
            let followingData = {
                user_id: this.$root.profile.user_id,
                community_url: this.$root.community.url,
                search: search
            };
            this.$http.get('/api/v1/user/' + this.$root.profile.user_id + '/following', { params: followingData }).then(response => {
                this.members = response.data.results;
                if (this.members.length === 0) {
                    this.showEmptyMessage = true;
                } else {
                    for (let i = 1; i < response.data.total_pages; i++) {
                        let page = i + 1;
                        let pageData = {
                            user_id: this.$root.profile.user_id,
                            community_url: this.$root.community.url,
                            search: search,
                            page: page
                        };
                        this.$http.get('/api/v1/user/' + this.$root.profile.user_id + '/following', {params: pageData}).then(response => {
                            this.members.push.apply(this.members, response.data.results);
                        }, response => {
                            console.log('Errored:');
                            console.log(response);
                        });
                    }
                }
            }, response => {
                if (response.status === 403) {
                    this.$root.$emit('show-private-message');
                }
            });
        },
        reinitGrid() {
            this.masonry.load();
        }
    }
}
</script>
